import { PROFILE_KEY } from './key'

// TODO remove when web doesn't use it
const FITNESS_DATA_PROFILE_KEYS = [
  PROFILE_KEY.GOAL,
  PROFILE_KEY.GOAL_OBSTACLE,
  PROFILE_KEY.DIET_TYPE,
  PROFILE_KEY.DESIRED_OUTCOME,
  PROFILE_KEY.FITNESS_LEVEL,
  PROFILE_KEY.TRAINING_FREQUENCY,
  PROFILE_KEY.WEEKLY_WORKOUTS_COUNT_GOAL,
  PROFILE_KEY.GENDER,
  PROFILE_KEY.BIRTHDAY,
  PROFILE_KEY.WEIGHT,
  PROFILE_KEY.HEIGHT,
  PROFILE_KEY.BODY_TYPE,
  PROFILE_KEY.GYM_ACCESS
]

const FITNESS_DATA_REQUIRED_PROFILE_KEYS = FITNESS_DATA_PROFILE_KEYS.filter(
  key => ![
    PROFILE_KEY.WEEKLY_WORKOUTS_COUNT_GOAL,
    PROFILE_KEY.BODY_TYPE
  ].includes(key)
)

const PROFILE_DEFAULT_WEIGHT_IN_KG = 70

export {
  FITNESS_DATA_PROFILE_KEYS,
  PROFILE_DEFAULT_WEIGHT_IN_KG,
  FITNESS_DATA_REQUIRED_PROFILE_KEYS
}
